import React, { useEffect, useState, useRef } from "react";
import ReactSelect from "react-select";
import Select from "react-select";
import "../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import Fade from "react-reveal/Fade";
import ProgressBar from "../components/ProgressBar";
import { Titles, Gender, MaritalValue, Countries } from "../utils";
import FileUploadComponent from "../components/FIleUpload";
import Terms from "../components/terms";
import Selfie from "../components/selfie";
import PDFIcon from "../assets/pdf-svg.svg";
import benefit from "../assets/benefits_icon.png";
import Checkbox from "@mui/material/Checkbox";
import { orange } from "@mui/material/colors";
import StatesAndLocalGov from "../statesAndLgas.json";
import Consent from "../components/Consent";

import {
  TextField,
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContentText,
  DialogContent,
  DialogActions,
  LinearProgress,
} from "@mui/material";
import DatePicker from "../components/DatePicker/DatePicker";
import { ArrowRight, Camera } from "react-bootstrap-icons";
import { set } from "date-fns";

const BasicInformation = ({ setForm, formData, navigation, loading }) => {
  const bottomRef = useRef(null);
  const topRef = useRef(null);
  const { customerId } = formData;

  const Identity = [
    { name: "DL", value: "Driver's License" },
    { name: "IP", value: "International Passport" },
    { name: "NIN", value: "National Identification Number" },
    { name: "VC", value: "Voters Card" },
  ];

  const INITIAL_DL_VALUE = {
    driversLicenseNumber: "",
    issueDate: new Date(),
    expirationDate: new Date(),
  };

  const INITIAL_IP_VALUE = {
    passportNumber: "",
    expirationDate: new Date(),
  };

  const INITIAL_NIN_VALUE = {
    nationalIdentificationNumber: "",
  };

  const INITIAL_VC_VALUE = {
    votersCardNumber: "",
  };

  const { previous, next, go } = navigation;
  const [allCardProducts, setAllCardProducts] = useState([]);
  const getCardProducts = async () => {
    try {
      const accessToken = sessionStorage.getItem("verifyTokenAccessToken");

      if (!accessToken) {
        throw new Error("No access token found in sessionStorage");
      }
      const response = await axios.get(API_URL + "/card_products", {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      setAllCardProducts(response?.data?.result);
    } catch (er) {}
  };
  const [accountType, setAccountType] = useState("");
  const [selected, setSelected] = useState(Identity[0].name);
  const [firstName, setFirstName] = useState("");
  const [merchantDetails, setMerchantDetails] = useState(null);

  const [lastName, setLastName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [NIN, setNIN] = useState("");
  const [dob, setDOB] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [title, setTitle] = useState("");
  const [gender, setGender] = useState("");
  const [religion, setReligion] = useState("");
  const [state, setState] = useState("");
  const [lga, setLGA] = useState("");
  const [address, setAddress] = useState("");
  const [currentAddress, setCurrentAddress] = useState("");
  const [cardDeliveryAddress, setCardDeliveryAddress] = useState("");
  const [branch, setBranch] = useState("");
  const [allBranch, setAllBranch] = useState([]);
  const [country, setCountry] = useState("Nigeria");
  const [altPhone, setAltPhone] = useState("");
  const [altEmail, setAltEmail] = useState("");

  const [maritalStatus, setMaritalStatus] = useState("");
  const [bvn, setBVN] = useState("");
  const [error, setError] = useState("");
  const [validationError, setValidationErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  const [fineInfo, setFileInfo] = useState(null);

  const [passportInfo, setPassportInfo] = useState(null);
  // console.log("passport:", passportInfo)
  const [utilityInfo, setUtilityInfo] = useState(null);
  const [identityInfo, setIdentityInfo] = useState(null);
  const [signatureInfo, setSignatureInfo] = useState(null);
  const [referenceInfo, setReferenceInfo] = useState(null);

  const [dlInfoPhoto, setDlInfoPhoto] = useState(null);
  const [ipInfoPhoto, setIpInfoPhoto] = useState(null);
  const [ninInfoPhoto, setNinInfoPhoto] = useState(null);
  const [vcInfoPhoto, setVcInfoPhoto] = useState(null);
  // console.log("driver:", driversLicensePhoto)

  const [showTerm, setShowTerm] = useState(false);
  const [showSelfie, setShowSelfie] = useState(false);
  const [agreementCheckBox, setAgreementCheckBox] = useState(false);
  const [showConsent, setShowConsent] = useState(false);
  const [consentCheckBox, setConsentCheckBox] = useState(false);
  const [selfieImg, setSelfieImg] = useState(null);

  const [allDataValid, setAllDataValid] = useState(false);
  const [rmCode, setRmCode] = useState("");
  const [motherMaidenName, setmotherMaidenName] = useState("");
  const [occupation, setOccupation] = useState("");
  const [utilityDate, setUtilitydate] = useState("");
  const [masterCard, setMasterCard] = useState("");
  const [masterCardDescription, setMasterCardDescription] = useState("");
  const [verveCard, setVerveCard] = useState("");
  const [verveCardDescription, setVerveCardDescription] = useState("");
  const [costOfCard, setCostOfCard] = useState("");
  const [cardType, setCardType] = useState("");

  const [clickCardIdentify, setClickCardIdentify] = useState(false);
  const [clickDriversLicense, setClickDriversLicense] = useState(false);
  const [clickInternationalPassport, setClickInternationalPassport] =
    useState(false);
  const [clickVotersCard, setClickVotersCard] = useState(false);
  const [clickNinNumber, setClickNinNumber] = useState(false);
  const [dlValue, setDlValue] = useState(INITIAL_DL_VALUE);
  const [ipValue, setIpValue] = useState(INITIAL_IP_VALUE);
  const [ninValue, setNinValue] = useState(INITIAL_NIN_VALUE);
  const [vcValue, setVcValue] = useState(INITIAL_VC_VALUE);
  const [stateOfOrigindata, setStateOfOrigindata] = useState([]);
  const [rmCodeData, setRmCodeData] = useState([]);

  const [checkedVerve, setCheckedVerve] = useState(false);
  const [checkedMaster, setCheckedMaster] = useState(false);
  const [allDetails, setAllDetails] = useState(false);
  const [instantIssuanceID, setInstantIssuanceID] = useState("");
  const [amount, setAmount] = useState("");
  const [filteredRmCode, setFilterRmCode] = useState([]);
  const [rmIsOpen, setRmIsOpen] = useState(false);
  const [finalRmCode, setFinalRmCode] = useState("");
  const [strRmCode, setStrRmCode] = useState("");

  const [residentState, setResidentState] = useState("");
  const [residentStateError, setResidentStateError] = useState("");
  const [residentLGA, setResidentLGA] = useState("");
  const [residentLGAError, setResidentLGAError] = useState("");
  const [localGovs, setLocalGovs] = useState([]);
  const [residentOtherLGA, setResidentOtherLGA] = useState("");
  const [residentOtherLGAError, setResidentOtherLGAError] = useState("");

  let tc = "";
  let gn = "";
  let ms = "";
  try {
    tc = Titles.filter((tt) => title.toUpperCase() == tt.title)[0].code;
  } catch (er) {
    tc = Titles[1].code;
  }

  try {
    gn = Gender.filter((gg) => gender == gg.gender)[0].code;
  } catch (er) {
    gn = Gender[0].code;
  }

  try {
    ms = MaritalValue.filter((ms) => maritalStatus == ms.status)[0].code;
  } catch (er) {
    ms = MaritalValue[0].code;
  }

  const body = {
    // tc  :  Titles?.filter((tt) => title?.toUpperCase() === tt?.title)[0]?.code,
    // gn  : Gender?.filter((gg) => gender === gg?.gender)[0]?.code,
    // ms  : MaritalValue?.filter((ms) => maritalStatus === ms?.status)[0]?.code,
    tc,
    gn,
    ms,
    accountType,
    lastName,
    firstName,
    middleName,
    address,
    address2: address,
    religion,
    phone,
    dob,
    email,
    bvn,
    state,
    lga,
    country,
    altPhone,
    altEmail,
    NIN,
    currentAddress,
    branch,
    rmCode,
    docutilityDate: utilityDate,
    occupation,
    motherMaidenName,
    amount: costOfCard,
    card_type: cardType,
    // new_cust_id
    new_cust_id: sessionStorage.getItem("customerId"),
    instantIssuanceID,
    cardDeliveryAddress,
    residentState,
    residentLGA, //:residentLGA=="Others"?residentOtherLGA:residentLGA,
    residentOtherLGA,
  };
  //  console.log(body);

  sessionStorage.setItem("body", JSON.stringify(body));

  const handleChangeforVerve = (event) => {
    setCheckedVerve(event.target.checked);
    // console.log(event.target.checked)
    if (checkedMaster === true) {
      setCheckedMaster(false);
      setVerveCard("");
    }
  };

  const handleChangeforMaster = (e) => {
    setCheckedMaster(e.target.checked);
    if (checkedVerve === true) {
      setCheckedVerve(false);
      setMasterCard("");
    }
  };
  // const [loading, setLoading] = useState(false);
  const API_URL = process.env.REACT_APP_BaseApi_URL;
  const API_URLAUTOSAVE = process.env.REACT_APP_BaseApi_URLAutosave;

  const mask = (word) => {
    if (word === "" || word === undefined) {
      return "";
    } else if (word.length <= 2) {
      return word;
    } else {
      var masked =
        word.substring(0, word.length - 4) +
        word.substring(word.length - 4, word.length).replace(/[a-z\d]/gi, "*");
      return masked;
    }
  };

  function longMask(word) {
    if (word === "" || word === undefined) {
      return "";
    } else if (word.length <= 2) {
      return word;
    } else {
      var masked =
        word.substring(0, word.length - 10).replace(/[a-z\d]/gi, "*") +
        word.substring(word.length - 15, word.length);
      return masked;
    }
  }

  useEffect(() => {
    let data = JSON.parse(sessionStorage.getItem("res"));
    // let data = verifyToken(localStorage.getItem("res"));

    const dbUserTitle = data?.Gender === "Male" ? "MR" : "MRS";
    setMerchantDetails(data?.merchantDetails);
    setFirstName(data?.FirstName);
    setLastName(data?.LastName);
    setMiddleName(data?.MiddleName);
    setDOB(data?.DOB);
    setPhone(data?.Phone);
    setEmail(data?.Email);
    setTitle(
      data?.Title == undefined || data?.Title == null || data?.Title == ""
        ? dbUserTitle
        : data?.Title,
    );
    setGender(data?.Gender);
    setState(data?.State);
    setLGA(data?.LGA);
    setAddress(data?.Address);
    setMaritalStatus(data?.MaritalStatus);
    setBVN(data?.BVN);
    getAllBranch();
    getCardProducts();
  }, []);

  // stateoforigindropdown
  useEffect(() => {
    const getStateofOrigin = async () => {
      const accessToken = sessionStorage.getItem("verifyTokenAccessToken");

      if (!accessToken) {
        throw new Error("No access token found in sessionStorage");
      }
      const response = await axios.get(API_URL + "/getStateCity/NG/AB", {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      setStateOfOrigindata(response.data.data);
    };

    getStateofOrigin();
  }, []);

  // /apitest/branches
  const getAllBranch = async () => {
    try {
      const accessToken = sessionStorage.getItem("verifyTokenAccessToken");

      if (!accessToken) {
        throw new Error("No access token found in sessionStorage");
      }
      const response = await axios.get(API_URL + "/branches", {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      setAllBranch(response?.data?.result);
    } catch (er) {}
  };

  useEffect(() => {
    if (
      accountType != "" &&
      religion != "" &&
      country != "" &&
      branch != "" &&
      trimStr(motherMaidenName) != "" &&
      trimStr(NIN)?.length == 11 &&
      // trimStr(altPhone) != "" &&
      // trimStr(altEmail) != "" &&
      trimStr(currentAddress) != "" &&
      currentAddress != "" &&
      trimStr(residentState) != "" &&
      ((trimStr(residentLGA) == "Others" && trimStr(residentOtherLGA) != "") ||
        (trimStr(residentLGA) != "Others" && trimStr(residentLGA) != "")) &&
      agreementCheckBox &&
      consentCheckBox
    ) {
      if (
        (checkedMaster === true || checkedVerve === true) &&
        cardType === ""
      ) {
        setAllDataValid(false);
      } else {
        setAllDataValid(true);
      }
    } else {
      setAllDataValid(false);
    }
  }, [
    NIN,
    checkedMaster,
    checkedVerve,
    motherMaidenName,
    cardType,
    altPhone,
    altEmail,
    accountType,
    religion,
    country,
    currentAddress,
    agreementCheckBox,
    consentCheckBox,
    branch,
    residentState,
    residentLGA,
    residentOtherLGA,
  ]);

  const handleClose = () => {
    setShowTerm(false);
  };
  const handleCloseSelfie = () => {
    setShowSelfie(false);
  };

  const SubmitSelfie = (selfieImg) => {
    setSelfieImg(selfieImg);
  };
  //  const Vervedata = [
  //   {
  //     id : "1",
  //     benefits : "ProvidusBank Verve Card is a local payment card that gives you real-time access to funds in your Savings or Current Naira account, allows you to conveniently pay for goods and services on all ATMs (Automated Teller Machines), POS and Web. It is acceptable at merchant locations where the Verve/Interswitch logos are displayed Access to account 24/7 through ATM, POS & WEB,Free Card Advisory Services Verve & Bank Reward Programmes ",

  //     value : "Classic/Gold Verve ",

  //     amountInstring : "(1000 NGN)",

  //     amount: "1000",
  //     instantIssuanceID: "1"
  //   },
  //   {
  //     id : "2",
  //     benefits : "ProvidusBank Black Verve Card is a premium payment card that gives you real-time access to funds in your HNI account, allows you to conveniently pay for goods and services on all ATMs (Automated Teller Machines), POS and Web. It is acceptable at merchant locations where the Verve/InterSwitch logos are displayed.Free card pouch and notepad box at onboarding ,Access to HNI Lounge at branches bankwide ,Free Card Advisory Services ,Higher Daily Transaction Limit ,Verve & Bank Reward Programmes ",

  //     value : "Black Verve",

  //     amountInstring : "(1000 NGN + N4000 lifestyle Enrolment Fees)",
  //     amount : "5000",
  //     instantIssuanceID: "2"
  //   },
  //   {
  //     id : "3",
  //     benefits : "ProvidusBank Platinum Verve Card is a premium payment card that gives you real-time access to funds in your HNI account, allows you to conveniently pay for goods and services on all ATMs (Automated Teller Machines), POS and Web. It is acceptable at merchant locations where the Verve/InterSwitch logos are displayed.Free card pouch and notepad box at onboarding,Access to HNI Lounge at branches bankwide ,Free Card Advisory Services ,Higher Daily Transaction Limit ,Verve & Bank Reward Programmes ",

  //     value : "Platinum Verve",

  //     amountInstring : "(1000 NGN + N4000 lifestyle Enrolment Fees)",
  //     amount : "5000",
  //     instantIssuanceID: "3"
  //   }

  //  ]

  //  const Masterdata = [
  //   {
  //     id : "1",
  //     benefits : "The Classic Mastercard is a Naira denominated debit card issued in partnership with MasterCard International. It is linked to customers current and/or savings account and can be used for transactions via various acceptance channels (ATM, POS and Web) both locally and internationally. ",
  //     value : "Classic Mastercard",
  //     amountInstring : "(1000 NGN)",
  //     amount: "1000",
  //     instantIssuanceID: "48"
  //   },
  //   {
  //     id : "2",
  //     benefits : "The Platinum Mastercard is a debit card issued in partnership with Mastercard International and avails cardholders exclusive access to premium benefits. Free access to Lounge at Lagos (Local & Int’l) and Abuja (Int’l) Airports VIP Lounge (MMA2) b. Gabfol Lounge (except MMA2),Access to over 600+ Airport lounges at a discounted rate, International transactions up to 3000USD/Month, Purchase Protection Offers,MyUs Premium Membership & Shipping Discount ,Eligibility for AVIS car rental at a discount,Higher International transactions up to 100,000USD/Annum",

  //     value : "Platinum Mastercard",
  //     amountInstring : "(1000 NGN + N4000 lifestyle Enrolment Fees)",

  //     amount: "5000",
  //     instantIssuanceID: "55"
  //   },
  //   {
  //     id : "3",
  //     benefits : "Nigeria's first eco-friendly contactless debit card. Free access to Gabfol lounges at Lagos & Abuja airport terminals ,Free access to Bi-Courtney Lounge at MMA2,Discounts at local merchant outlets e.g. Tino Electronics, Hotel Reno, Dutch Flowers, Dro health, Swiss International Hotel: The Vistana, Sari signature, Pricecut.com etc.",
  //     value : "ProvidusEco",
  //     amountInstring : "(1000 NGN + N4000 lifestyle Enrolment Fees)",
  //     amount : "5000",
  //     instantIssuanceID: "75"
  //   }

  //  ]
  // async function sendOTP(account) {
  //   const response = await axios.post(process.env.SEND_OTP, {
  //     account,
  //   });

  //   return response.data;
  // }

  // const Vervedata = [
  //   {
  //     id : "1",
  //     benefits : "ProvidusBank Verve Card is a local payment card that gives you real-time access to funds in your Savings or Current Naira account, allows you to conveniently pay for goods and services on all ATMs (Automated Teller Machines), POS and Web. It is acceptable at merchant locations where the Verve/Interswitch logos are displayed Access to account 24/7 through ATM, POS & WEB,Free Card Advisory Services Verve & Bank Reward Programmes ",

  //     value : "Gold Verve ",

  //     amountInstring : "(1075 NGN)",

  //     amount: "1075",
  //     instantIssuanceID: "4"
  //   },
  //   {
  //     id : "2",
  //     benefits : "ProvidusBank Black Verve Card is a premium payment card that gives you real-time access to funds in your HNI account, allows you to conveniently pay for goods and services on all ATMs (Automated Teller Machines), POS and Web. It is acceptable at merchant locations where the Verve/InterSwitch logos are displayed.Free card pouch and notepad box at onboarding ,Access to HNI Lounge at branches bankwide ,Free Card Advisory Services ,Higher Daily Transaction Limit ,Verve & Bank Reward Programmes ",

  //     value : "Black Verve",

  //     amountInstring : "(1075 NGN + N4000 lifestyle Enrolment Fees)",
  //     amount : "5075",
  //     instantIssuanceID: "1"
  //   },
  //   {
  //     id : "3",
  //     benefits : "ProvidusBank Platinum Verve Card is a premium payment card that gives you real-time access to funds in your HNI account, allows you to conveniently pay for goods and services on all ATMs (Automated Teller Machines), POS and Web. It is acceptable at merchant locations where the Verve/InterSwitch logos are displayed.Free card pouch and notepad box at onboarding,Access to HNI Lounge at branches bankwide ,Free Card Advisory Services ,Higher Daily Transaction Limit ,Verve & Bank Reward Programmes ",

  //     value : "Platinum Verve",

  //     amountInstring : "(1075 NGN + N4000 lifestyle Enrolment Fees)",
  //     amount : "5075",
  //     instantIssuanceID: "3"
  //   }

  //  ]

  //  const oldMasterdata = [
  //   {
  //     id : "1",
  //     benefits : "The Classic Mastercard is a Naira denominated debit card issued in partnership with MasterCard International. It is linked to customers current and/or savings account and can be used for transactions via various acceptance channels (ATM, POS and Web) both locally and internationally. ",
  //     value : "Classic Mastercard",
  //     amountInstring : "(1075 NGN)",
  //     amount: "1075",
  //     instantIssuanceID: "48"
  //   },
  //   {
  //     id : "2",
  //     benefits : "The Platinum Mastercard is a debit card issued in partnership with Mastercard International and avails cardholders exclusive access to premium benefits. Free access to Lounge at Lagos (Local & Int’l) and Abuja (Int’l) Airports VIP Lounge (MMA2) b. Gabfol Lounge (except MMA2),Access to over 600+ Airport lounges at a discounted rate, International transactions up to 3000USD/Month, Purchase Protection Offers,MyUs Premium Membership & Shipping Discount ,Eligibility for AVIS car rental at a discount,Higher International transactions up to 100,000USD/Annum",

  //     value : "Platinum Mastercard",
  //     amountInstring : "(1075 NGN + N4000 lifestyle Enrolment Fees)",

  //     amount: "5075",
  //     instantIssuanceID: "49"
  //   },
  //   {
  //     id : "3",
  //     benefits : "Nigeria's first eco-friendly contactless debit card. Free access to Gabfol lounges at Lagos & Abuja airport terminals ,Free access to Bi-Courtney Lounge at MMA2,Discounts at local merchant outlets e.g. Tino Electronics, Hotel Reno, Dutch Flowers, Dro health, Swiss International Hotel: The Vistana, Sari signature, Pricecut.com etc.",
  //     value : "ProvidusEco",
  //     amountInstring : "(1075 NGN + N4000 lifestyle Enrolment Fees)",
  //     amount : "5075",
  //     instantIssuanceID: "72"
  //   }

  //  ]

  // const Masterdata = [
  //   {
  //     id: "1",
  //     benefits:
  //       "The Classic Mastercard is a Naira denominated debit card issued in partnership with MasterCard International. It is linked to customers current and/or savings account and can be used for transactions via various acceptance channels (ATM, POS and Web) both locally and internationally. ",
  //     value: "Classic Mastercard",
  //     amountInstring: "(1075 NGN)",
  //     amount: "1075",
  //     instantIssuanceID: "48",
  //   },
  //   {
  //     id: "2",
  //     benefits:
  //       "The Platinum Mastercard is a debit card issued in partnership with Mastercard International and avails cardholders exclusive access to premium benefits. Free access to Lounge at Lagos (Local & Int’l) and Abuja (Int’l) Airports VIP Lounge (MMA2) b. Gabfol Lounge (except MMA2),Access to over 600+ Airport lounges at a discounted rate, International transactions up to 3000USD/Month, Purchase Protection Offers,MyUs Premium Membership & Shipping Discount ,Eligibility for AVIS car rental at a discount,Higher International transactions up to 100,000USD/Annum",

  //     value: "Platinum Mastercard",
  //  amountInstring: "(1075 NGN + N4,300.00 Lifestyle Enrolment Fee + N32,250.00 Annual Lifestyle Access Fee ) ",
  //     amount: "37625.00",
  //     instantIssuanceID: "49",
  //   },
  //   {
  //     id: "3",
  //     benefits:
  //       "Nigeria's first eco-friendly contactless debit card. Free access to Gabfol lounges at Lagos & Abuja airport terminals ,Free access to Bi-Courtney Lounge at MMA2,Discounts at local merchant outlets e.g. Tino Electronics, Hotel Reno, Dutch Flowers, Dro health, Swiss International Hotel: The Vistana, Sari signature, Pricecut.com etc.",
  //     value: "ProvidusEco",
  //   amountInstring: "(1075 NGN + N4,300.00 Lifestyle Enrolment Fee + N32,250.00 Annual Lifestyle Access Fee ) ",
  //     amount: "37625.00",
  //     instantIssuanceID: "72",
  //   },
  // ];

  const autosave = async () => {
    ValidateEmail(altEmail);
    let tc = "";
    let gn = "";
    let ms = "";
    try {
      tc = await Titles.filter((tt) => title.toUpperCase() == tt.title)[0].code;
    } catch (er) {
      tc = Titles[1].code;
    }

    try {
      gn = await Gender.filter((gg) => gender == gg.gender)[0].code;
    } catch (er) {
      gn = Gender[0].code;
    }

    try {
      ms = await MaritalValue.filter((ms) => maritalStatus == ms.status)[0]
        .code;
    } catch (er) {
      ms = MaritalValue[0].code;
    }

    const body = {
      tc,
      gn,
      ms,
      accountType,
      lastName,
      firstName,
      middleName,
      address,
      address2: address,
      religion,
      phone,
      dob,
      email,
      bvn,
      state,
      lga,
      country,
      altPhone,
      NIN,
      altEmail,
      currentAddress,
      branch,
      rmCode: finalRmCode,
      docutilityDate: utilityDate,
      occupation,
      motherMaidenName,
      amount: costOfCard,
      cardType,
      // new_cust_id
      instantIssuanceID,
      new_cust_id: sessionStorage.getItem("customerId"),
      merchantName: merchantDetails?.merchantName,
      eventCode: merchantDetails?.eventCode
        ? merchantDetails?.eventCode
        : merchantDetails?.rmCode,
      cardDeliveryAddress,
      residentState,
      residentLGA, //:residentLGA=="Others"?residentOtherLGA:residentLGA,
      residentOtherLGA,
    };

    await axios.post(API_URLAUTOSAVE + "/account/auto-save/text", body);
  };

  const handleVerveChange = (e) => {
    //  setVerveCard(e.target.value)
    //  console.log(e.target.value)
    let selecteditem = allCardProducts.filter(
      (item) => item.value == e.target.value,
    );
    //  console.log(selecteditem[0]?.benefits)

    setVerveCard(e.target.value);
    setCardType(e.target.value);
    setVerveCardDescription(selecteditem[0]?.benefits);
    setCostOfCard(selecteditem[0]?.amount);
    setInstantIssuanceID(selecteditem[0]?.instantIssuanceID);
    //  console.log(costOfCard)
  };
  const handleMasterChange = (e) => {
    setMasterCard(e.target.value);
    setCardType(e.target.value);
    // console.log(e.target.value)

    let selecteditem = allCardProducts.filter(
      (item) => item.value == e.target.value,
    );
    //  console.log(selecteditem[0]?.benefits)

    //  console.log(cardType)
    setMasterCardDescription(selecteditem[0]?.benefits);
    setCostOfCard(selecteditem[0]?.amount);
    setInstantIssuanceID(selecteditem[0]?.instantIssuanceID);

    // console.log(costOfCard)
  };

  const trimStr = (str) => {
    if (str != null && str != undefined) {
      return str.trim();
    }
    return "";
  };

  const ValidateEmail = (mail) => {
    if (
      /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail) ||
      trimStr(mail) == ""
    ) {
      setValidationErrors({ ...validationError, altEmail: "" });
      return true;
    }
    setValidationErrors({ ...validationError, altEmail: "Invalid Email" });

    return false;
  };
  const handleBranchChange = (e) => {
    setBranch(e.currentTarget.value);
    var branch = e.currentTarget.value;
    //  console.log(e.currentTarget.value)
    //  console.log(branch)
    if (branch) {
      const accessToken = sessionStorage.getItem("verifyTokenAccessToken");

      if (!accessToken) {
        throw new Error("No access token found in sessionStorage");
      }
      setStrRmCode("");
      // console.log(branch)
      const getRmCode = async () => {
        const response = await axios.get(API_URL + `/getRm_list/${branch}`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });
        console.log(response?.data?.result);
        setRmCodeData(mapDataToOptions(response?.data?.result));
      };

      getRmCode();
    }
  };

  useEffect(() => {
    const localGovs =
      StatesAndLocalGov.filter((row) => row.state == residentState).length > 0
        ? StatesAndLocalGov.filter((row) => row.state == residentState)[0]?.lgas
        : [];
    // console.log(localGovs)
    const lga = localGovs.length > 0 ? [...localGovs, "Others"] : [];
    setLocalGovs(lga);
  }, [residentState]);

  // const saveChanges = async () => {
  //    const data = {

  //    }
  //    const response = await axios.post("", data)
  //    console.log(response)
  // }

  const customStyles = {
    control: (base) => ({
      ...base,
      height: "48px",
    }),
  };

  function mapDataToOptions(data) {
    return data.map((item) => ({
      value: item.rmCode,
      label: item.rmCode + " " + item.employeeName,
    }));
  }

  const handleSetRmCode = (query) => {
    setStrRmCode(query?.label);
    let resp =
      query?.value != "" && query?.value != null && query?.value != undefined
        ? query.value
        : "";
    setFinalRmCode(resp);
  };

  return (
    <div style={{ position: "relative" }}>
      <>
        <ProgressBar page="basicInfo" />
        <Fade bottom>
          <form id="msform">
            <fieldset>
              <h2 className="fs-title" ref={topRef}>
                BASIC INFORMATION
              </h2>
              {/* <div className="d-flex">
                 <p>Click <a href = {link}>here</a> to continue </p>

              </div> */}

              <h3 className="fs-subtitle text-danger">
                Fields marked with <sup>*</sup> are mandatory
              </h3>
              <p className="text-danger">
                {error != null && error != "" ? error : validationError.error}
              </p>
              <hr />

              <div className="row">
                <div className="col-md-4">
                  <div className="form-group">
                    <label
                      className={accountType != "" ? "" : "text-danger"}
                      htmlFor="exampleFormControlSelect1"
                    >
                      Account Type <sup className="text-danger">*</sup>
                    </label>
                    <select
                      className="form-control select2"
                      id="exampleFormControlSelect1"
                      name="accountType"
                      defaultValue={accountType}
                      onBlur={() => autosave()}
                      onChange={(e) => setAccountType(e.currentTarget.value)}
                      required
                    >
                      <option value="">Select Account Type</option>
                      {gender?.toUpperCase() == "FEMALE" ? (
                        <>
                          {" "}
                          <option value="184">Regal Savings</option>
                          <option value="52">Regal Current</option>{" "}
                        </>
                      ) : null}
                      <option value="65">Savings</option>
                      <option value="40">Current</option>
                    </select>
                    <p className="text-danger">{validationError.accountType}</p>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-group">
                    <label
                      className={religion != "" ? "" : "text-danger"}
                      htmlFor="exampleInputEmail1"
                    >
                      Religion <sup className="text-danger">*</sup>
                    </label>
                    <select
                      className="form-control select2"
                      id="exampleFormControlSelect2"
                      name="religion"
                      defaultValue={religion}
                      onBlur={() => autosave()}
                      // onBlur = {autosave()}
                      onChange={(e) => setReligion(e.currentTarget.value)}
                      required
                    >
                      <option value="">Select your Religion</option>
                      <option value="1">Christianity</option>
                      <option value="2">Islam</option>
                      <option value="4">Hindu</option>
                      <option value="3">Others</option>
                    </select>
                    <p className="text-danger">{validationError.religion}</p>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-group">
                    <label
                      className={country != "" ? "" : "text-danger"}
                      htmlFor="exampleInputEmail1"
                    >
                      Country of Residence <sup className="text-danger">*</sup>
                    </label>
                    <ReactSelect
                      value={{ label: country, value: country }}
                      onChange={(e) => {
                        setCountry(e.value);
                      }}
                      onBlur={() => autosave()}
                      options={Countries}
                      styles={customStyles}
                    />

                    {/* <select
                      className="form-control select2"
                      id="exampleFormControlSelect3"
                      name="country"
                      defaultValue={country}
                      onChange={(e) => setCountry(e.currentTarget.value)}
                      required
                    >
                      <option>Select a Country</option>

                      {Countries.map((row, index) => (
                        <option value={row} key={index}>
                          {row}
                        </option>
                      ))}
                    </select> */}
                    <p className="text-danger">{validationError.country}</p>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="title">Title</label>
                    <select
                      className="form-control"
                      id="title"
                      name="title"
                      disabled
                    >
                      <option value={title}>{title}</option>
                      <option>MR</option>
                      <option>Miss</option>
                      <option>MRS</option>
                    </select>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">Date of Birth</label>
                    <input
                      type="text"
                      className="form-control"
                      id="exampleInputEmail1"
                      placeholder="Date of Birth"
                      name="dob"
                      value={mask(dob)}
                      disabled
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">Gender</label>
                    <select
                      className="form-control"
                      id="exampleFormControlSelect1"
                      disabled
                    >
                      <option value={gender}>{gender}</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">First Name</label>
                    <input
                      type="text"
                      className="form-control"
                      id="exampleInputEmail1"
                      placeholder="First Name"
                      name="firstname"
                      value={mask(firstName)}
                      disabled
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">Middle Name</label>
                    <input
                      type="text"
                      className="form-control"
                      id="exampleInputEmail1"
                      placeholder="Middle Name"
                      name="middlename"
                      value={mask(middleName)}
                      disabled
                    />
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">Last Name</label>
                    <input
                      type="text"
                      className="form-control"
                      id="exampleInputEmail1"
                      placeholder="Last Name"
                      name="lastname"
                      value={mask(lastName)}
                      disabled
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1"> Phone Number</label>
                    <input
                      type="text"
                      className="form-control"
                      id="exampleInputEmail1"
                      placeholder="Phone Number"
                      name="phone"
                      value={mask(phone)}
                      disabled
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">Email</label>
                    <input
                      type="text"
                      className="form-control"
                      id="exampleInputEmail1"
                      placeholder="Email"
                      name="email"
                      value={longMask(email)}
                      disabled
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-4">
                  <div className="form-group">
                    {/* <label
                      htmlFor="exampleFormControlTextarea1"
                      className={
                        altPhone != "" && (validationError?.altPhone==undefined||validationError?.altPhone=="")  ? "" : "text-danger"
                      }
                    >
                      Preferred Phone <sup className="text-danger">*</sup>
                    </label>

                    <input
                      type="text"
                      className="form-control"
                      id="exampleInputEmail1"
                      placeholder="Preferred Phone Number"
                      name="altPhone"
                      value={altPhone}
                      onChange={(e) => {
                        const value = e.currentTarget.value;
                        if (/^\+?[0-9]*$/.test(value)) {
                          setAltPhone(value);
                        }
                      }}
                      onBlur = {()=>autosave()}
                    />
                    <p className="text-danger">{validationError.altPhone}</p> */}
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    {/* <label
                      htmlFor="exampleFormControlTextarea1"
                      className={
                        altEmail != "" && (validationError?.altEmail==undefined||validationError?.altEmail=="") ? "" : "text-danger"
                      }
                    >

Preferred Email <sup className="text-danger">*</sup>
                    </label>
                  
                    <input
                      type="text"
                      className="form-control"
                      id="exampleInputEmail1"
                      placeholder="Preferred Email"
                      name="altEmail"
                      value={altEmail}
                      onChange={(e) => setAltEmail(e.currentTarget.value)}
                      onBlur = {()=>autosave()}
                      
                    />
                    <p className="text-danger">{validationError.altEmail}</p> */}
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-group">
                    <label
                      htmlFor="exampleFormControlTextarea1"
                      className={
                        NIN != "" && NIN?.length == 11 ? "" : "text-danger"
                      }
                    >
                      NIN <sup className="text-danger">*</sup>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="exampleInputEmail1"
                      placeholder="Enter NIN"
                      name="NIN"
                      value={NIN}
                      onChange={(e) => {
                        if (isNaN(e.currentTarget.value)) {
                          return;
                        }
                        setNIN(e.currentTarget.value);
                      }}
                      // onChange={(e) => setNIN(e.currentTarget.value)}
                      onBlur={() => autosave()}
                    />
                    <p className="text-danger">{validationError.NIN}</p>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">State of Origin</label>
                    <select
                      className="form-control"
                      id="exampleFormControlSelect1"
                      name="state"
                      disabled
                    >
                      <option value={state}>{state}</option>
                    </select>

                    {/* <option value={state}>{state}</option> */}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">
                      Local Government Area
                    </label>
                    <select
                      className="form-control"
                      id="exampleFormControlSelect1"
                      name="LGA"
                      disabled
                    >
                      <option value={lga}>{lga}</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label
                      className={branch != "" ? "" : "text-danger"}
                      htmlFor="exampleInputEmail1"
                    >
                      Branch <sup className="text-danger">*</sup>
                    </label>
                    <select
                      className="form-control select2"
                      id="exampleFormControlSelect3"
                      name="branch"
                      onChange={handleBranchChange}
                      required
                      // onBlur = {autosave()}
                      onBlur={() => autosave()}
                    >
                      <option value="">Select a Branch</option>

                      {allBranch?.map((row, index) => {
                        return (
                          <option value={row?.code} key={index}>
                            {row?.name}
                          </option>
                        );
                      })}

                      {/* <option value="202">Head Office (Victoria Island)</option>
                       <option value="203">Victoria Island</option>
                       <option value="204">Abuja Main</option>
                       <option value="205">Festac</option>
                        <option value="206">Gbagada</option>
                       <option value="207">Ikota</option>
                       <option value="209">Ikeja</option>
                        <option value="210">Apapa</option>
                       <option value="211">Akure</option>
                       <option value="212">Nnamdi Azikwe</option>
                       <option value="213">Lekki</option> */}
                    </select>
                    <p className="text-danger">{validationError.branch}</p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label
                    // htmlFor="exampleInputEmail1"
                    >
                      RM Code
                    </label>
                    {/* <Select
                        //  className='border-red-300 text-yellow-500 w-[30%] m-2 mx-auto'
                         defaultValue={{ label: rmCode, value: rmCode }}
                         value={{ label: rmCode, value: rmCode }}
                         onInputChange={(e)=>handleInputChange(e)}
                         options={rmCodeData}
                        menuIsOpen={rmCode?.length >= 4}
                        /> */}
                    <ReactSelect
                      value={{ label: strRmCode, value: strRmCode }}
                      onInputChange={(e) => {
                        setRmCode(e);
                      }}
                      onChange={(e) => handleSetRmCode(e)}
                      onBlur={() => autosave()}
                      options={rmCodeData}
                      styles={customStyles}
                      menuIsOpen={rmCode?.length >= 4}
                    />
                    {/* <input
                     value = {rmCode}
                     className="form-control"
                      id="exampleFormControlInput1"
                      name = "rmCode"
                      onBlur = { (e)=>handleInputOnBlur(e) }
                     onChange = {(e) =>{setRmCode(e.target.value)}}
                    />
                      <ul className = "rmDropdown"> 
                          {filteredRmCode.map(item => <li key={item?.id}>{item.RMCODE} {item?.EMPLOYEENAME}</li>)}
                     </ul> */}
                    {/* <select
                      className  = "form-control"
                      // id = "exampleInputEmail1"
                      name = "rmCode"
                      disabled = { branch ? false : true }
                      onBlur = {()=>autosave()}
                      onChange = {(e) =>{setRmCode(e.target.value)}}
                      // onBlur = {autosave()}
                    >
                      <option value = "">Select RM Code</option>
                     {
                      rmCodeData?.map((item) =>{
                        return(
                          <option className="px-3" value = {item.RMCODE}>{item.RMCODE} {item.EMPLOYEENAME}</option>
                        ) 
                      })

                     }
                    </select> */}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label
                      className={motherMaidenName != "" ? "" : "text-danger"}
                      htmlFor="exampleInputEmail1"
                    >
                      Mother's maiden name <sup className="text-danger">*</sup>
                    </label>
                    {/* <label htmlFor="exampleInputEmail1">Mother's maiden name</label> */}
                    <input
                      className="form-control"
                      id="exampleFormControlSelect1"
                      name="motherMaidenName"
                      value={motherMaidenName || ""}
                      onChange={(e) => {
                        setmotherMaidenName(e.target.value);
                      }}
                      // onBlur = {autosave()}
                      onBlur={() => autosave()}
                    ></input>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">
                      Occupation / Nature of Business
                    </label>
                    <input
                      className="form-control"
                      id="exampleFormControlSelect1"
                      name="occupation"
                      value={occupation}
                      onChange={(e) => {
                        setOccupation(e.target.value);
                      }}
                      onBlur={() => autosave()}

                      // onBlur = {autosave()}
                    ></input>
                  </div>
                </div>
              </div>

              {/* <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <label htmlFor="exampleFormControlTextarea1">
                        Contact Address
                      </label>
                      <textarea
                        className="form-control"
                        id="exampleFormControlTextarea1"
                        rows="3"
                        name="address"
                        value={longMask(address)}
                        placeholder="Please type your full address"
                        disabled
                      ></textarea>
                    </div>
                  </div>
                </div> */}
              <div>
                <p>Card Selection</p>
                <div className="row">
                  <div className="col-md-6 align-items-center h-full">
                    <div className="row h-100 ">
                      <div className="col my-auto d-flex align-items-center justify-content-center">
                        <label
                          className="checkbox-label"
                          htmlFor="exampleInputEmail1"
                        >
                          Master Card
                        </label>
                        <Checkbox
                          label="Master Card"
                          checked={checkedMaster}
                          onChange={handleChangeforMaster}
                          inputProps={{ "aria-label": "controlled" }}
                          sx={{
                            "&.Mui-checked": {
                              color: orange[200],
                            },
                          }}
                        />
                        {/* <input className="ml-3" type = "checkbox" /> */}
                      </div>

                      <div className="col my-auto justify-center d-flex align-items-center justify-content-center">
                        <div className="d-flex align-items-center">
                          <label
                            className="checkbox-label"
                            htmlFor="exampleInputEmail1"
                          >
                            Verve Card
                          </label>
                          <Checkbox
                            label="Verve Card"
                            checked={checkedVerve}
                            onChange={handleChangeforVerve}
                            inputProps={{ "aria-label": "controlled" }}
                            sx={{
                              "&.Mui-checked": {
                                color: orange[200],
                              },
                            }}
                          />

                          {/* <input
                                    
                                   className="ml-3" 
                                   type = "checkbox" /> */}
                        </div>
                      </div>
                    </div>

                    {/* <label>Verve Card</label>
                          <input type = "checkbox"/> */}
                    {/* <select
                              className="form-control"
                              id="exampleFormControlSelect1"
                              name="verveCard"
                              value = {verveCard}
                              onChange = { handleVerveChange }
                              
                              disabled={ masterCard ? true : false }

                          
                             >
                               <option value="">Select a Verve Card</option>
                             {
                              Vervedata.map((item)=>{
                                return(
                                  <option key ={item.id} value = {item.value}>{item.value}</option>
                                )
                                  // <option key ={item.id}>{item.value}</option>

                              })
                             }
                             
                           </select> */}
                    {
                      // verveCard &&
                      // <div className="container-fluid mh-10 mt-2 bg-white rounded shadow">
                      // <div className="row h-100">
                      //    <div className="col-4 border-right d-flex align-items-center justify-content-center">
                      //      <img className="" src = {benefit}></img>
                      //     </div>
                      //      <div className = "col-8 rounded-right justify-content-center right-side">
                      //       {/* <p>
                      //         ProvidusBank Verve Card is a local payment card that gives you real-time access to funds in your Savings or Current Naira account, allows you to conveniently pay for goods and services on all ATMs (Automated Teller Machines), POS and Web.
                      //         </p> */}
                      //       <p className="content">{verveCardDescription}</p>
                      //     </div>
                      //    </div>
                      // </div>
                    }
                  </div>
                  <div className="col-md-6">
                    {checkedMaster ? (
                      <div className="form-group">
                        <label htmlFor="exampleInputEmail1">Master Card</label>
                        <select
                          className="form-control"
                          id="exampleFormControlSelect1"
                          name="masterCard"
                          value={masterCard}
                          onChange={handleMasterChange}
                          // disabled={verveCard ? true : false}

                          // onBlur = {autosave()}
                          onBlur={() => autosave()}
                        >
                          <option value="">Select a Master Card</option>
                          {allCardProducts.map((item) => {
                            // console.log(item.benefits)

                            return (
                              <option
                                title={item.benefits}
                                key={item.id}
                                value={item.value}
                              >
                                {" "}
                                {item.value} - {item.amountInstring}{" "}
                              </option>
                            );
                          })}
                        </select>
                        {
                          // masterCard &&
                          // <div className="container-fluid  mt-2 bg-white rounded shadow">
                          // <div className="row h-100">
                          //    <div className="col-4 border-right d-flex align-items-center justify-content-center">
                          //      <img className=" " src = {benefit}></img>
                          //     </div>
                          //      <div className = "col-8 rounded-right right-side">
                          //       {/* <p>
                          //         ProvidusBank Verve Card is a local payment card that gives you real-time access to funds in your Savings or Current Naira account, allows you to conveniently pay for goods and services on all ATMs (Automated Teller Machines), POS and Web.
                          //         </p> */}
                          //       <p className="content">{masterCardDescription}</p>
                          //     </div>
                          //    </div>
                          // </div>
                        }
                      </div>
                    ) : checkedVerve ? (
                      <div>
                        <label>Verve Card</label>
                        <select
                          className="form-control"
                          id="exampleFormControlSelect1"
                          name="verveCard"
                          value={verveCard}
                          onChange={handleVerveChange}
                          //  disabled={ masterCard ? true : false }
                          onBlur={() => autosave()}
                          // onBlur = {autosave()}
                        >
                          <option value="">Select a Verve Card</option>
                          {allCardProducts.map((item) => {
                            return (
                              <option
                                title={item.benefits}
                                key={item.id}
                                value={item.value}
                              >
                                {item.value} - {item.amountInstring}
                              </option>
                            );
                            // <option key ={item.id}>{item.value}</option>
                          })}
                        </select>
                        {
                          //      verveCard &&
                          //        <div className="container-fluid mh-10 mt-2 bg-white rounded shadow">
                          //                 <div className="row h-100">
                          //                     <div className="col-4 border-right d-flex align-items-center justify-content-center">
                          //                        <img className="" src = {benefit}></img>
                          //                    </div>
                          //                     <div className = "col-8 rounded-right justify-content-center right-side">
                          // {/* <p>
                          //   ProvidusBank Verve Card is a local payment card that gives you real-time access to funds in your Savings or Current Naira account, allows you to conveniently pay for goods and services on all ATMs (Automated Teller Machines), POS and Web.
                          //   </p> */}
                          //                     <p className="content">{verveCardDescription}</p>
                          //                      </div>
                          //             </div>
                          //         </div>
                        }
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>

              <div className="row">
                <div
                  className={residentLGA == "Others" ? "col-md-4" : "col-md-6"}
                >
                  <div className="form-group">
                    <label
                      className={residentState != "" ? "" : "text-danger"}
                      htmlFor="exampleInputEmail1"
                    >
                      Current State
                    </label>

                    {/* <ReactSelect
                         value={{ label: residentState, value: residentState }}
                         onChange={(e) => {
                           setResidentState(e.value);
                         }}
                         // onBlur = {()=>autosave()}
                         options={Countries}
                         styles={customStyles}
   
                       /> */}
                    <select
                      className="form-control"
                      id="exampleFormControlSelect1"
                      name="residentState"
                      //  >
                      //   <option value={residentState}>{residentState}</option>
                      //   </select>

                      required
                      defaultValue={residentState}
                      // onBlur = {()=>autosave()}
                      onChange={(e) => setResidentState(e.currentTarget.value)}
                    >
                      <option value={""}>Select Current State</option>

                      {StatesAndLocalGov.map((row, index) => (
                        <option value={row.state} key={index}>
                          {row.state}
                        </option>
                      ))}
                    </select>
                    <p className="text-danger">{residentStateError}</p>
                  </div>
                </div>
                <div
                  className={residentLGA == "Others" ? "col-md-4" : "col-md-6"}
                >
                  <div className="form-group">
                    <label
                      className={residentLGA != "" ? "" : "text-danger"}
                      htmlFor="exampleInputEmail1"
                    >
                      Current Local Government Area
                    </label>
                    <select
                      className="form-control"
                      id="exampleFormControlSelect1"
                      name="residentLGA"
                      defaultValue={residentLGA}
                      // onBlur = {()=>autosave()}
                      onChange={(e) => {
                        setResidentLGA(e.currentTarget.value);
                      }}
                      required
                    >
                      <option value={""}>Select Current LGA</option>

                      {localGovs.map((row, index) => (
                        <option value={row} key={index}>
                          {row}
                        </option>
                      ))}
                    </select>
                    <p className="text-danger">{residentLGAError}</p>
                  </div>
                </div>
                {residentLGA == "Others" ? (
                  <div className="col-md-4">
                    <div className="form-group">
                      <label
                        className={residentOtherLGA != "" ? "" : "text-danger"}
                        htmlFor="exampleInputEmail1"
                      >
                        Other LGA
                      </label>
                      <input
                        className="form-control"
                        id="exampleFormControlSelect1"
                        name="residentOtherLGA"
                        type="text"
                        value={residentOtherLGA}
                        onChange={(e) =>
                          setResidentOtherLGA(e.currentTarget.value)
                        }
                      ></input>
                      {/* <p className="text-success">{accountName}</p> */}
                      <p className="text-danger">{residentOtherLGAError}</p>
                    </div>
                  </div>
                ) : null}
              </div>

              <div className="row">
                <div className="col-md-12">
                  <div className="form-group">
                    <label
                      htmlFor="exampleFormControlTextarea1"
                      className={
                        trimStr(currentAddress) != "" ? "" : "text-danger"
                      }
                    >
                      Current Address <sup className="text-danger">*</sup>
                    </label>
                    <textarea
                      className="form-control"
                      id="exampleFormControlTextarea1"
                      rows="3"
                      name="currentAddress"
                      value={currentAddress}
                      placeholder="Please type your full address"
                      onChange={(e) => setCurrentAddress(e.currentTarget.value)}
                      onBlur={() => autosave()}

                      // onBlur = {autosave()}
                    ></textarea>
                    <p className="text-danger">
                      {validationError.currentAddress}
                    </p>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <div className="form-group">
                    <label htmlFor="exampleFormControlTextarea1">
                      Card Delivery Address
                    </label>
                    <textarea
                      className="form-control"
                      id="exampleFormControlTextarea1"
                      rows="3"
                      name="cardDeliveryAddress"
                      value={cardDeliveryAddress}
                      placeholder="Please type your card delivery address"
                      onChange={(e) =>
                        setCardDeliveryAddress(e.currentTarget.value)
                      }
                      onBlur={() => autosave()}

                      // onBlur = {autosave()}
                    ></textarea>
                    {/* <p className="text-danger">
                      {validationError.cardDeliveryAddress}
                    </p> */}
                  </div>
                </div>
              </div>

              <p>
                <input
                  style={{ marginRight: "5px" }}
                  type="checkbox"
                  required={true}
                  checked={agreementCheckBox}
                  onChange={() => setAgreementCheckBox(!agreementCheckBox)}
                />
                I Agree to the
                <a
                  href="#"
                  onClick={() => setShowTerm(true)}
                  style={{ color: "#efb331" }}
                >
                  {" "}
                  Terms & Conditions
                </a>
              </p>
              <p>
                <input
                  style={{ marginRight: "5px" }}
                  type="checkbox"
                  required={true}
                  checked={consentCheckBox}
                  onChange={() => setConsentCheckBox(!consentCheckBox)}
                />
                I Consent to the
                <a
                  href="#"
                  onClick={() => setShowConsent(true)}
                  style={{ color: "#efb331" }}
                >
                  {" "}
                  Consent Agreement
                </a>
              </p>

              <>
                <input
                  type="button"
                  name="next"
                  className={
                    allDataValid ? "next action-button" : " disabled-button"
                  }
                  value="next"
                  // onClick={onSubmit}
                  disabled={!allDataValid}
                  onClick={() => go("identityValidation")}
                  // onClick={() => setShowTerm(true)}
                />
              </>

              {/* <input
                  type="button"
                  name="next"
                  className="btn next action-button"
                  value="Processing..."
                  disabled
                /> */}

              <div
                className="d-flex align-items-center"
                ref={bottomRef}
                // ref={(el) => {
                //   bottomRef = el;
                // }}
              >
                <p className="text-danger align-self-center">
                  {error != null && error != "" ? error : validationError.error}
                </p>
              </div>
              <label>
                <b>
                  {" "}
                  <a
                    href="https://oap.providusbank.com/providus_files/reference-form.pdf"
                    target="_blank"
                    style={{ textDecoration: "none", color: "#efb331" }}
                  >
                    {" "}
                    Download Reference{" "}
                    <img
                      className="mr-2"
                      src={PDFIcon}
                      alt="reference"
                      width="25"
                    />
                  </a>
                </b>
              </label>
            </fieldset>
          </form>
          <br />
        </Fade>
      </>

      <Terms showTerm={showTerm} handleClose={handleClose} />
      <Consent
        showConsent={showConsent}
        handleClose={() => setShowConsent(false)}
        name={firstName}
      />
      <Selfie
        showSelfie={showSelfie}
        handleClose={handleCloseSelfie}
        SubmitSelfie={SubmitSelfie}
      />
    </div>
  );
};

export default BasicInformation;
